
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/program-details",
      function () {
        return require("private-next-pages/[region]/[language]/program-details/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/program-details"])
      });
    }
  